import { getDay, DisplayDate } from 'owa-datetime';
import createWeeklyRecurrence from './createWeeklyRecurrence';
import type RecurrenceType from 'owa-service/lib/contract/RecurrenceType';
import { DAYS_OF_WEEK } from './constants';

export default function createWeeklyRecurrenceFromDate(
    startDate: DisplayDate,
    interval: number,
    endDate: DisplayDate
): RecurrenceType {
    let dayString = DAYS_OF_WEEK[getDay(startDate)];

    return createWeeklyRecurrence(dayString, interval, startDate, endDate);
}
